import {
  GET_CUSTOMER_CREDIT_CARD_SUCCESS,
  CUSTOMER_CREDIT_CARD_REQUESTING,
  LIST_CUSTOMER_CREDIT_CARDS_SUCCESS,
  RESET_CUSTOMER_CREDIT_CARD_ISFETCHING,
  DELETE_CUSTOMER_CREDIT_CARD_SUCCESS,
  RESET_CUSTOMER_CREDIT_CARD_QUERY
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_CREDIT_CARD_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESET_CUSTOMER_CREDIT_CARD_QUERY: {
      return {
        ...state,
        isFetching: false,
        query: null,
        recordCount: null
      };
    }
    case CUSTOMER_CREDIT_CARD_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_CUSTOMER_CREDIT_CARDS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.customerCreditCards.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        recordCount: action.payload.total,
        isFetching: false
      };
    }
    case GET_CUSTOMER_CREDIT_CARD_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false,
        query: null,
        recordCount: null
      };
    }
    case DELETE_CUSTOMER_CREDIT_CARD_SUCCESS: {
      const data = { ...state.data };
      delete data[action.payload.id];
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getDefaultCreditCard = (customerCreditCard) => {
  if (!customerCreditCard.data) {
    return null;
  }
  const customerCreditCardIds = Object.keys(customerCreditCard.data);
  const defaultCreditCardId = customerCreditCardIds.filter((id) => {
    if (customerCreditCard.data[id].isDefault) {
      return id;
    }
    return null;
  });
  if (defaultCreditCardId.length === 1) {
    return customerCreditCard.data[defaultCreditCardId[0]];
  }
  return null;
};

export const getNonDefaultCreditCards = (customerCreditCard) => {
  if (!customerCreditCard.data) {
    return null;
  }
  const customerCreditCardIds = Object.keys(customerCreditCard.data);
  const nonDefaultIds = customerCreditCardIds.filter(
    (id) => !customerCreditCard.data[id].isDefault
  );
  return nonDefaultIds.map((id) => customerCreditCard.data[id]);
};
